// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.repeat-count[data-v-216dad62] {\n\tdisplay: inline-block;\n\tfont-size: 11px;\n\tfont-weight: 700;\n\tpadding: 1px 6px;\n\tmargin: 0 2px 0 4px;\n\tbackground: var(--w-band);\n\tcolor: var(--w-ink);\n\tborder-radius: 4px;\n\tvertical-align: 1px;\n}\n.repeat-chevron[data-v-216dad62] {\n\tcolor: var(--w-ink-faint);\n\tfont-size: 12px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
